'use client';

import { useMemo } from 'react';

import { useTickerLogos } from '../../../../edge/dashboard/_components/useTickerLogos';
import { PricedHolding } from '../portfolioActionUtils';
import { PORTFOLIO_TABLE_HEADER_CELL_CLASS, PORTFOLIO_TABLE_NUMERIC_CLASS } from '../FinancialTable/watchlistQuotesTableChrome';
import { HoldingsDesktopRow, HoldingsMobileRow } from './HoldingRows';

interface HoldingsTableProps {
  rows: PricedHolding[];
}

export const HoldingsTable = ({ rows }: HoldingsTableProps) => {
  const totalValue = rows.reduce((total, row) => total + row.marketValue, 0);
  const holdingSymbols = useMemo(() => rows.map(row => row.symbol), [rows]);
  const logoBySymbol = useTickerLogos(holdingSymbols);

  if (rows.length === 0) return null;

  return (
    <>
      <div className="sm:hidden">
        {rows.map(row => (
          <HoldingsMobileRow key={row.symbol} logo={logoBySymbol[row.symbol]} row={row} />
        ))}
      </div>
      <div className="hidden max-h-[min(420px,60vh)] overflow-auto sm:block">
        <table className="w-full min-w-[760px] border-collapse text-sm">
          <thead className="sticky top-0 z-10 bg-white">
            <tr className="border-b border-slate-200 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-500">
              <th className={`${PORTFOLIO_TABLE_HEADER_CELL_CLASS} min-w-[16rem]`}>Symbol</th>
              <th className={`${PORTFOLIO_TABLE_HEADER_CELL_CLASS} ${PORTFOLIO_TABLE_NUMERIC_CLASS} text-right`}>
                Shares
              </th>
              <th className={`${PORTFOLIO_TABLE_HEADER_CELL_CLASS} ${PORTFOLIO_TABLE_NUMERIC_CLASS} text-right`}>
                Price
              </th>
              <th className={`${PORTFOLIO_TABLE_HEADER_CELL_CLASS} ${PORTFOLIO_TABLE_NUMERIC_CLASS} text-right`}>
                Market value
              </th>
              <th className={`${PORTFOLIO_TABLE_HEADER_CELL_CLASS} ${PORTFOLIO_TABLE_NUMERIC_CLASS} text-right`}>
                Total gain
              </th>
              <th className={`${PORTFOLIO_TABLE_HEADER_CELL_CLASS} ${PORTFOLIO_TABLE_NUMERIC_CLASS} text-right`}>
                Weight
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <HoldingsDesktopRow key={row.symbol} logo={logoBySymbol[row.symbol]} row={row} totalValue={totalValue} />
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
